module.exports = __webpack_public_path__ + "1a7eca98130f13f508b8de2eeeaeb57d.MP3";